const LanguageResource = {
    en: {
        translation: {
            "IntroductionMessage": `Hi! This application is not OFFICIAL. It is made to make calculating Swinburne CGPAs easier rather than manual math. This is just a pet project written in React. If there are any bugs please report to joekanesiew@outlook.com. Thank you for using Unofficial Swinburne CGPA Calculator.`,
            "EmptySemester": "You currently have no semesters! Start by Creating a Semester.",
            "AddSemester": "Add Semester",
            "ShowGradeValue": "Show Grade Value",
            "ShowSubjectName": "Show Subject Value",
            "Format": "GPA Format",
            "ToggleFormatHelperText": "Toggle between Australian or Malaysian format for GPA value.",
            "DefaultNoSubjectsLabel": "Default Number of Subjects",
            "DefaultNoSubjectsHelperText": "Default number of subjects you take. Will auto generate when you add a new semester. This you can change...",
            "CreditHours": "Input Credit Hours",
            "DisclaimerCreditHours": "*Disclaimer: Do not change this field unless Swinburne has made any explicit changes to all subjects' credit points. Otherwise, the credit points will remain as 12.5 as of 2nd August 2022",
            "Australia": "Australia",
            "Malaysian": "Malaysian",
            "AddSubjects": "Add Subjects",
            "Semester": "Semester",
            "RemoveSemester": "Remove Semester",
            "SubjectName": "Subject Name",
            "SelectGrade": "Select Grade",
            "Reset": "Reset",
            "ProcessGPA": "Process GPA",
            "TotalCreditHours": "Total Credit Hours",
            "TotalGPA": "Total GPA",
            "TotalCredit": "Total GPA",
            "GradeValue": "Grade Value",
            "ChangeFormatDialogTitle": "Warning: Change GPA Format",
            "ChangeFormatDialogMessage": "Are you sure you want to change gpa format? Doing so will reset your output. Proceed?",
            "OK": "OK",
            "Cancel": "Cancel",
            "DoNotRemind": "Don't Remind Me Again",
        }
    },
    cn: {
        translation: {
            "IntroductionMessage": `嗨! 所显示的网站是为了Swiburne大学的学生以及老师们容易计算学生GPA分数而制造。这个网站是由React Framework而建成的。如果发现网站有问题，请联络joekanesiew@outlook.com。感谢使用Unofficial Swinburne CGPA Calculator。`,
            "EmptySemester": "正在无学期，请加入新学期.",
            "AddSemester": "新学期",
            "ShowGradeValue": "显示成绩",
            "ShowSubjectName": "显示科目主题",
            "Format": "GPA格式",
            "ToggleFormatHelperText": "转换GPA格式.",
            "DefaultNoSubjectsLabel": "科目",
            "DefaultNoSubjectsHelperText": "正在所拿的科目总数",
            "CreditHours": "学分",
            "DisclaimerCreditHours": "*注意: 请别编辑学分除非Swinburne大学通知学分有任何的改变.",
            "Australia": "澳大利亚",
            "Malaysian": "马来西亚",
            "AddSubjects": "新科目",
            "Semester": "学期",
            "RemoveSemester": "删除学期",
            "SubjectName": "科目主题",
            "SelectGrade": "成绩选择",
            "Reset": "重新",
            "ProcessGPA": "计算GPA",
            "TotalCreditHours": "学分总数",
            "TotalGPA": "GPA总数",
            "TotalCredit": "GPA总数",
            "GradeValue": "分数",
            "ChangeFormatDialogTitle": "注意:正在转换GPA格式",
            "ChangeFormatDialogMessage": "确定转换GPA格式吗?这样做会影响GPA的计算。",
            "OK": "好的",
            "Cancel": "取消",
            "DoNotRemind": "以后别通知我",
        }
    },
    jp: {
        translation: {
            "EmptySemester": "まだ学期が入っていない。",
            "IntroductionMessage": "どうも。このサイトは自分の暇で作ってみたプロジェクト。SwinburneのGPAを簡単に計算するために作ってきた。このサイトの使ったフレームワークはReactです。どうぞ使ってください。バグがあったらjoekanesiew@outlook.comにメールをしてお願いします。このサイトを使ってくれてありがとうございます。",
            "DoNotRemind": "二度と表示しない",
            "AddSemester": "新しい学期",
            "ShowGradeValue": "成績を表示",
            "ShowSubjectName": "科目を表示",
            "Format": "GPAフォーマット",
            "ToggleFormatHelperText": "GPAフォーマットを変わる",
            "DefaultNoSubjectsLabel": "科目の数",
            "DefaultNoSubjectsHelperText": "新しい学期を作る時の科目の数",
            "CreditHours": "単位",
            "DisclaimerCreditHours": "*注意:Swinburne大学科目の単位が変わらない限りこのフイールドを編集しないで下さい。",
            "Australia": "オーストラリア",
            "Malaysian": "マレーシア",
            "AddSubjects": "新しい科目",
            "Semester": "学期",
            "RemoveSemester": "学期を削除",
            "SubjectName": "科目",
            "SelectGrade": "グレードの選択",
            "Reset": "リセット",
            "ProcessGPA": "GPAを計算",
            "TotalCreditHours": "単位のまとめ",
            "TotalGPA": "GPAのまとめ",
            "GradeValue": "グレードの価値",
            "ChangeFormatDialogTitle": "注意:GPAの編集",
            "ChangeFormatDialogMessage": "GPAフォーマットを編集したら計算したGPAがリセットしまう。続きますか?",
            "OK": "はい",
            "Cancel": "キヤンセル",
        }
    }
};

export default LanguageResource;